<template>
<transition name="fade" @after-enter="showContent = true" @after-leave="showContent = false">
      <div class="fixed inset-0 w-full h-full flex justify-center items-center z-50" v-if="showModal">
        <div class="absolute inset-0 w-full h-full bg-green-600 opacity-75" @click="$emit('close')"></div>

        <transition name="fade-bottom" >
          <div class="bg-white rounded-md shadow-2xl px-3 py-12 lg:px-6  w-full mx-4 lg:mx-0 lg:w-1/3 text-center z-50 relative" v-if="showContent">
            <div class="absolute top-0 right-0 w-12 h-12 mt-4 mr-4 cursor-pointer select-none" @click="$emit('close')">
              <svg class="h-8 w-8 text-support-300 fill-current" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.24 14.83C16.4038 15.0213 16.4894 15.2674 16.4797 15.519C16.47 15.7707 16.3656 16.0095 16.1876 16.1876C16.0095 16.3656 15.7707 16.47 15.519 16.4797C15.2674 16.4894 15.0213 16.4038 14.83 16.24L12 13.41L9.16999 16.24C8.97869 16.4038 8.73261 16.4894 8.48094 16.4797C8.22926 16.47 7.99052 16.3656 7.81243 16.1876C7.63433 16.0095 7.53 15.7707 7.52028 15.519C7.51056 15.2674 7.59616 15.0213 7.75999 14.83L10.59 12L7.75999 9.16999C7.59616 8.97869 7.51056 8.73261 7.52028 8.48094C7.53 8.22926 7.63433 7.99052 7.81243 7.81243C7.99052 7.63433 8.22926 7.53 8.48094 7.52028C8.73261 7.51056 8.97869 7.59616 9.16999 7.75999L12 10.59L14.83 7.75999C15.0213 7.59616 15.2674 7.51056 15.519 7.52028C15.7707 7.53 16.0095 7.63433 16.1876 7.81243C16.3656 7.99052 16.47 8.22926 16.4797 8.48094C16.4894 8.73261 16.4038 8.97869 16.24 9.16999L13.41 12L16.24 14.83Z"/>
              </svg>
          </div>
          <svg class="text-green-600 inline-block fill-current mb-6" width="157" height="157" viewBox="0 0 157 157" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M78.5 157C121.854 157 157 121.854 157 78.5C157 35.1456 121.854 0 78.5 0C35.1456 0 0 35.1456 0 78.5C0 121.854 35.1456 157 78.5 157Z"/>
            <path d="M155.529 32.2589L141.669 18.5212C139.829 16.6812 136.762 16.6812 134.8 18.5212L75.5566 79.727L49.9213 54.4597C48.0813 52.6198 45.0149 52.6198 43.0526 54.4597L30.7868 66.6028C28.9468 68.4428 28.9468 71.5092 30.7868 73.3491L71.7543 113.948C72.8583 115.052 74.3302 115.42 75.802 115.297C77.2739 115.42 78.7457 115.052 79.8497 113.948L155.529 39.1275C157.369 37.1649 157.369 34.0985 155.529 32.2589Z" fill="#EDFAF9"/>
          </svg>
          <p class="text-2xl text-support-700 mb-2">{{title}}</p>
          <p class="text-xl text-gray-500">{{subtitle}}</p>
        </div>
        </transition>
      </div>

      </transition>
</template>

<script>
    export default {
        name: 'Modal',
        props: ['title', 'subtitle', 'showModal'],
        data() {
            return {
                showContent: false
            };
        },
    }
</script>

<style>

</style>
